import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AiAgents = _resolveComponent("AiAgents")
  const _component_Sources = _resolveComponent("Sources")
  const _component_Research = _resolveComponent("Research")
  const _component_AiTabs = _resolveComponent("AiTabs")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["answer-tabs", {attention: $options.ai_question && $props.lastAnswer}])
  }, [
    _createVNode(_component_AiTabs, {
      modelValue: $options.active_tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.active_tab) = $event)),
      tabs: $options.tabs,
      disabled: !$options.completed
    }, {
      agents: _withCtx(() => [
        _createVNode(_component_AiAgents, {
          class: "agents",
          data: $props.item.data,
          flat: ""
        }, null, 8 /* PROPS */, ["data"])
      ]),
      sources: _withCtx(() => [
        _createVNode(_component_Sources, {
          sources: $props.sources,
          loading: $props.loading
        }, null, 8 /* PROPS */, ["sources", "loading"])
      ]),
      tasks: _withCtx(() => [
        _createVNode(_component_Research, {
          completed: $options.completed,
          "chat-id": $props.chatId,
          reasoning: $options.reasoning,
          class: "research",
          mode: "expanded"
        }, null, 8 /* PROPS */, ["completed", "chat-id", "reasoning"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "tabs", "disabled"])
  ], 2 /* CLASS */))
}